var Midttrafik2016 = Midttrafik2016 || {}

Midttrafik2016.ticketguide = new function () {
    var self = this

    this.init = function () {
        if ($('#ticket-guide').length) {
            self.ticketguide()
        }
    }

    this.ticketguide = function () {

        $(".select-group div.s1 .option-tabs").click(function () {
            sss1 = $.trim( $(this).html() );
            var id = "#" + $(this).val();
            $(".select-group-hidden.s1").hide();
            $(".level-s1").hide();
            $(".level-s2").show();
            $(".progressbar.s2").show();
            $(id).fadeIn();
        });
        
        $(".select-group div.s2 .option-tabs").click(function () {
            sss2 = $.trim( $(this).html() );
            var id = "#" + $(this).val();
            $(".select-group-hidden.s2").hide();
            $(".level-s2").hide();
            $(".level-s3").show();
            $(".progressbar.s3").show();

            $(id).fadeIn();
        });

        $(".select-group div.s3 .option-tabs").click(function () {
            sss3 = $.trim( $(this).html() );
            var id = "#" + $(this).val();
            // $(".select-group-hidden.s3").hide();
            $(".level-s3").hide();
            $(".level-s4").first().show();
            $(".progressbar.s4").show();

            

            
            $(id).fadeIn();
            $(".recomendation-chosen").html(
             '<li>' +sss1 + '</li>'+
             '<li>' +sss2 + 'Rejser pr. måned'+
             '</li>' + '<li>' +sss3 + '</li>');
        });

    


        // GO back function
        $(".s2.guide-go-back").click(function () {
            $(".level-s1").show();
            $(".level-s2").hide();
            $(".s1.select-box").val("")
            $(".progressbar.s2").hide();

        });

        $(".s3.guide-go-back").click(function () {
            $(".level-s2").show();
            $(".level-s3").hide();
            $(".s2.select-box").val("")
            $(".progressbar.s3").hide();

        });

        $(".s4.guide-go-back").click(function () {
            $(".level-s3").show();
            $(".level-s4").hide();
            $(".s3.select-box").val("")
            $(".progressbar.s4").hide();
        

        });

        $( document).ready(function () {
            $(".s1.guide-go-back").hide();
        });
            
    }
    
}